import { TrackingAction } from 'openapi';

export const TRACKING_ACTIONS_TRANSLATION_KEYS = {
  [TrackingAction.PAY]: 'titles.paid',
  [TrackingAction.APPROVE]: 'titles.approved',
  [TrackingAction.VALIDATE]: 'titles.validated',
  [TrackingAction.BOOK]: 'titles.booked',
  [TrackingAction.REJECT]: 'titles.rejected',
  [TrackingAction.SETTLE]: 'titles.settle'
};
